

export const index = 10;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/docs/user-guide/mobile-usage/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/10.DrcQsHRM.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/C8t-7i39.js","_app/immutable/chunks/IHki7fMi.js","_app/immutable/chunks/DW5DwYHW.js"];
export const stylesheets = ["_app/immutable/assets/10.D2S0_QXR.css"];
export const fonts = [];
